export enum RoleTypes {
  P,
  C,
  A,
  SO,
  SA,
  O,
}
export type RolesTypesType = keyof typeof RoleTypes
